// extracted by mini-css-extract-plugin
module.exports = {"cv977ol":"cv977ol"};